/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BroadcastAlertTranslationDto
 */
export interface BroadcastAlertTranslationDto {
    /**
     * Locale this copy is written in.
     * @type {string}
     * @memberof BroadcastAlertTranslationDto
     */
    'locale': BroadcastAlertTranslationDtoLocaleEnum;
    /**
     * Alert headline, stored verbatim in `Alert.title`.
     * @type {string}
     * @memberof BroadcastAlertTranslationDto
     */
    'title': string;
    /**
     * Alert body, stored verbatim in `Alert.message`.
     * @type {string}
     * @memberof BroadcastAlertTranslationDto
     */
    'message': string;
    /**
     * CTA label for this locale. Only rendered when `actionUrl` is set; when omitted the app falls back to its own translated \"Take action\" label.
     * @type {string}
     * @memberof BroadcastAlertTranslationDto
     */
    'actionLabel'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BroadcastAlertTranslationDtoLocaleEnum {
    En = 'en',
    De = 'de'
}


